import {MissingTranslationHandler, MissingTranslationHandlerParams} from "@ngx-translate/core";

export class CaseInsensitiveMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): any {
    const key = Object.keys(params.translateService.translations[params.translateService.currentLang])
      .filter((s) => s.localeCompare(params.key, undefined, {sensitivity: 'accent'}) == 0);
    if (key && key.length) {
      return params.translateService.translations[params.translateService.currentLang][key[0]];
    }
    return params.key;
  }
}
